import _ from 'lodash';
import { FormattedMessage } from 'react-intl';

import DocumentsByType from './DocumentsByType/DocumentsByType';

export const UploadedDocuments = ({ uploadedDocuments }) => (
    <>
        <div className="mb-l text-l font-bold">
            <FormattedMessage
                id="_.trading_data.uploaded_documents.title"
                defaultMessage="Uploaded documents"
            />
        </div>
        <div className="mb-m">
            {!_.isEmpty(uploadedDocuments) ? (
                _.map(uploadedDocuments, (doc, documentType) => (
                    <DocumentsByType
                        key={documentType}
                        documentType={documentType}
                        documents={doc}
                    />
                ))
            ) : (
                <FormattedMessage
                    id="_.trading_data.uploaded_documents.no_uploaded_documents"
                    defaultMessage="You have no uploaded documents."
                />
            )}
        </div>
    </>
);
